export const POST_COURSE_FOLLOWUPS = "/api/all-folders/:param/post-courses"
export const POST_COURSE_FOLLOWUP = "/api/all-folders/:param/post-courses/:postCourseFollowUpParam"
